<template>
  <b-card-code>
    <!-- Tabs for Task Form and Chat -->
    <b-tabs v-if="ifEdit" v-model="tabIndex" class="task-tabs">
      <b-tab title="Task Details" active>
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="4" v-if='$store.state.app.user_data&&($store.state.app.user_data.role== "employee" || $store.state.app.user_data.role== "admin")'>
            <b-form-group>
              <label>Assign To</label>
                <v-select v-model="assigntotype" placeholder="None" :options="['Employee','Channelpartner']" @input="handleEmployeeOption">
                </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Name</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Assign To">
                <v-select v-model="assignto" label="fullname" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="userOptions" >
                  <template
                    #option="{ fullname, profile_image, username, color }"
                  >
                    <b-avatar :src="getprofileImage(profile_image)" />
                    <span :class="'font-weight-bolder text-' + color">
                      {{ fullname }} ({{ username }})</span
                    >
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Work Type</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Work Type">
                <v-select v-model="worktype" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="['Office Work', 'Personal Work', 'Social Work']" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Task Type</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Task Type">
                <v-select v-model="tasktype" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="['One Time', 'Repeat']" @input="handleTaskTypeChange" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="tasktype === 'Repeat'">
            <b-form-group>
              <label>Occurance</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" :rules="tasktype === 'Repeat' ? 'required' : ''" name="Occurance">
                <v-select v-model="occurance" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="['Daily', 'Weekly', 'Monthly']" @input="handleOccuranceChange" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="occurance === 'Weekly'">
            <b-form-group>
              <label>Select Day</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" :rules="occurance === 'Weekly' ? 'required' : ''" name="Select Day">
                <v-select v-model="selectedDay" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="occurance === 'Monthly'">
            <b-form-group>
              <label>Select Date</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" :rules="occurance === 'Monthly' ? 'required' : ''" name="Select Date">
                <v-select v-model="selectedDate" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="Array.from({length: 31}, (_, i) => (i + 1).toString())" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>CC</label>
              <v-select v-model="cc" label="fullname" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Select users" :options="ccOptions" multiple :clearable="true" 
                :searchable="true" :close-on-select="false" 
                class="cc-select-with-search">
                <template
                  #option="{ fullname, profile_image, username, color }"
                >
                  <b-avatar :src="getprofileImage(profile_image)" />
                  <span :class="'font-weight-bolder text-' + color">
                    {{ fullname }} ({{ username }})</span
                  >
                </template>
                <template #selected-option="{ fullname, profile_image, username, color }">
                  <b-avatar :src="getprofileImage(profile_image)" size="sm" />
                  <span :class="'font-weight-bolder text-' + color">
                    {{ fullname }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Task</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Task">
                <b-form-input v-model="task" type="text" :state="errors.length > 0 ? false : null"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" placeholder="Enter Task" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Priority</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Priority">
                <v-select v-model="priority" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
                  placeholder="None" :options="['High', 'Medium', 'Low']" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Description</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Description">
                <b-form-textarea placeholder="Enter Description" v-model="description" rows="2" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Status</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Status">
                <v-select v-model="status" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
                  placeholder="None" :options="['Open', 'Pending', 'Complete']" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Dead Line</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Dead Line">
                <flat-pickr v-model="deadline" class="form-control" :config="{
                  dateFormat: 'd/m/Y',
                }" style="background-color: transparent" />
                <!-- <b-form-input
                  v-model="deadline"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Dead Line"
                /> -->
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Attachment 1</label>
              <b-form-file
                v-model="documents.attachment1"
                placeholder="Select Document"
                drop-placeholder="Drop file here..."
                @input="handleChangeFile($event, 'task', 'attachment1')"
                accept="image/*"
              />
            </b-form-group>
            <attachment :data="documents.attachment1" />
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Attachment 2</label>
              <b-form-file
                v-model="documents.attachment2"
                placeholder="Select Document"
                drop-placeholder="Drop file here..."
                @input="handleChangeFile($event, 'task', 'attachment2')"
                accept="image/*"
              />
            </b-form-group>
            <attachment :data="documents.attachment2" />
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Voice Note</label>
              <div class="voice-note-container">
                <div class="d-flex align-items-center mb-2">
                  <b-button
                    v-if="!isRecording"
                    variant="danger"
                    size="sm"
                    @click="startRecording"
                    :disabled="submitDisable"
                    class="mr-2"
                  >
                    <feather-icon icon="MicIcon" size="16" class="mr-1" />
                    Start Recording
                  </b-button>
                  <b-button
                    v-else
                    variant="warning"
                    size="sm"
                    @click="stopRecording"
                    class="mr-2"
                  >
                    <feather-icon icon="SquareIcon" size="16" class="mr-1" />
                    Stop Recording
                  </b-button>
                  <span v-if="isRecording" class="text-danger">
                    <feather-icon icon="RadioIcon" size="14" class="mr-1" />
                    Recording... {{ formatTime(recordingTime) }}
                  </span>
                </div>
                <!-- Voice Note Indicator -->
                <div v-if="documents.voice_note" class="voice-note-indicator mt-2">
                  <div class="d-flex align-items-center">
                    <feather-icon icon="Volume2Icon" size="20" class="text-success mr-2" />
                    <span class="text-success mr-2">Voice note attached</span>
                    <b-button
                      :variant="isPlaying ? 'success' : 'outline-primary'"
                      size="sm"
                      @click="togglePlayVoiceNote"
                      class="mr-2"
                    >
                      <feather-icon 
                        :icon="isPlaying ? 'PauseIcon' : 'PlayIcon'" 
                        size="14" 
                        class="mr-1"
                        :class="isPlaying ? 'pulse-animation' : ''"
                      />
                      {{ isPlaying ? 'Playing...' : 'Play' }}
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="removeVoiceNote"
                    >
                      <feather-icon icon="XIcon" size="14" class="mr-1" />
                      Remove
                    </b-button>
                  </div>
                  <audio
                    ref="audioPlayer"
                    :src="documents.voice_note"
                    style="display: none;"
                    @play="onAudioPlay"
                    @pause="onAudioPause"
                    @ended="onAudioEnded"
                  ></audio>
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Remarks</label>
              <b-form-input v-model="remarks" type="text" placeholder="Enter Remarks" />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button variant="primary" type="submit" @click.prevent="submitForm($event)" class="mr-4"
              :disabled="submitDisable">
              Submit
            </b-button>
            <b-button variant="primary" @click="onClickBack">Back </b-button>
          </b-col>
        </b-row>
          </b-form>
        </validation-observer>
      </b-tab>
      
      <b-tab title="Chat" v-if="ifEdit && id">
        <TaskChat :taskId="id" />
      </b-tab>
    </b-tabs>

    <!-- No tabs for new task (create mode) -->
    <div v-if="!ifEdit">
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4" v-if='$store.state.app.user_data&&($store.state.app.user_data.role== "employee" || $store.state.app.user_data.role== "admin")'>
              <b-form-group>
                <label>Assign To</label>
                  <v-select v-model="assigntotype" placeholder="None" :options="['Employee','Channelpartner']" @input="handleEmployeeOption">
                  </v-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Name</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Assign To">
                  <v-select v-model="assignto" label="fullname" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="userOptions" >
                    <template
                      #option="{ fullname, profile_image, username, color }"
                    >
                      <b-avatar :src="getprofileImage(profile_image)" />
                      <span :class="'font-weight-bolder text-' + color">
                        {{ fullname }} ({{ username }})</span
                      >
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Work Type</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Work Type">
                  <v-select v-model="worktype" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="['Office Work', 'Personal Work', 'Social Work']" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Task Type</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Task Type">
                  <v-select v-model="tasktype" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="['One Time', 'Repeat']" @input="handleTaskTypeChange" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="tasktype === 'Repeat'">
              <b-form-group>
                <label>Occurance</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" :rules="tasktype === 'Repeat' ? 'required' : ''" name="Occurance">
                  <v-select v-model="occurance" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="['Daily', 'Weekly', 'Monthly']" @input="handleOccuranceChange" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="occurance === 'Weekly'">
              <b-form-group>
                <label>Select Day</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" :rules="occurance === 'Weekly' ? 'required' : ''" name="Select Day">
                  <v-select v-model="selectedDay" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="occurance === 'Monthly'">
              <b-form-group>
                <label>Select Date</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" :rules="occurance === 'Monthly' ? 'required' : ''" name="Select Date">
                  <v-select v-model="selectedDate" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    placeholder="None" :options="Array.from({length: 31}, (_, i) => (i + 1).toString())" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>CC</label>
                <v-select v-model="cc" label="fullname" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Select users" :options="ccOptions" multiple :clearable="true" 
                  :searchable="true" :close-on-select="false" 
                  class="cc-select-with-search">
                  <template
                    #option="{ fullname, profile_image, username, color }"
                  >
                    <b-avatar :src="getprofileImage(profile_image)" />
                    <span :class="'font-weight-bolder text-' + color">
                      {{ fullname }} ({{ username }})</span
                    >
                  </template>
                  <template #selected-option="{ fullname, profile_image, username, color }">
                    <b-avatar :src="getprofileImage(profile_image)" size="sm" />
                    <span :class="'font-weight-bolder text-' + color">
                      {{ fullname }}
                    </span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Task</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Task">
                  <b-form-input v-model="task" type="text" :state="errors.length > 0 ? false : null"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" placeholder="Enter Task" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Priority</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Priority">
                  <v-select v-model="priority" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
                    placeholder="None" :options="['High', 'Medium', 'Low']" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Description</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Description">
                  <b-form-textarea placeholder="Enter Description" v-model="description" rows="2" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Status</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Status">
                  <v-select v-model="status" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
                    placeholder="None" :options="['Open', 'Pending', 'Complete']" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Dead Line</label>
                <label style="color: red !important">*</label>
                <validation-provider #default="{ errors }" rules="required" name="Dead Line">
                  <flat-pickr v-model="deadline" class="form-control" :config="{
                    dateFormat: 'd/m/Y',
                  }" style="background-color: transparent" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Attachment 1</label>
                <b-form-file
                  v-model="documents.attachment1"
                  placeholder="Select Document"
                  drop-placeholder="Drop file here..."
                  @input="handleChangeFile($event, 'task', 'attachment1')"
                  accept="image/*"
                />
              </b-form-group>
              <attachment :data="documents.attachment1" />
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Attachment 2</label>
                <b-form-file
                  v-model="documents.attachment2"
                  placeholder="Select Document"
                  drop-placeholder="Drop file here..."
                  @input="handleChangeFile($event, 'task', 'attachment2')"
                  accept="image/*"
                />
              </b-form-group>
              <attachment :data="documents.attachment2" />
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Voice Note</label>
                <div class="voice-note-container">
                  <div class="d-flex align-items-center mb-2">
                    <b-button
                      v-if="!isRecording"
                      variant="danger"
                      size="sm"
                      @click="startRecording"
                      :disabled="submitDisable"
                      class="mr-2"
                    >
                      <feather-icon icon="MicIcon" size="16" class="mr-1" />
                      Start Recording
                    </b-button>
                    <b-button
                      v-else
                      variant="warning"
                      size="sm"
                      @click="stopRecording"
                      class="mr-2"
                    >
                      <feather-icon icon="SquareIcon" size="16" class="mr-1" />
                      Stop Recording
                    </b-button>
                    <span v-if="isRecording" class="text-danger">
                      <feather-icon icon="RadioIcon" size="14" class="mr-1" />
                      Recording... {{ formatTime(recordingTime) }}
                    </span>
                  </div>
                  <div v-if="documents.voice_note" class="voice-note-indicator mt-2">
                    <div class="d-flex align-items-center">
                      <feather-icon icon="Volume2Icon" size="20" class="text-success mr-2" />
                      <span class="text-success mr-2">Voice note attached</span>
                      <b-button
                        :variant="isPlaying ? 'success' : 'outline-primary'"
                        size="sm"
                        @click="togglePlayVoiceNote"
                        class="mr-2"
                      >
                        <feather-icon 
                          :icon="isPlaying ? 'PauseIcon' : 'PlayIcon'" 
                          size="14" 
                          class="mr-1"
                          :class="isPlaying ? 'pulse-animation' : ''"
                        />
                        {{ isPlaying ? 'Playing...' : 'Play' }}
                      </b-button>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        @click="removeVoiceNote"
                      >
                        <feather-icon icon="XIcon" size="14" class="mr-1" />
                        Remove
                      </b-button>
                    </div>
                    <audio
                      ref="audioPlayer"
                      :src="documents.voice_note"
                      style="display: none;"
                      @play="onAudioPlay"
                      @pause="onAudioPause"
                      @ended="onAudioEnded"
                    ></audio>
                  </div>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Remarks</label>
                <b-form-input v-model="remarks" type="text" placeholder="Enter Remarks" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button variant="primary" type="submit" @click.prevent="submitForm($event)" class="mr-4"
                :disabled="submitDisable">
                Submit
              </b-button>
              <b-button variant="primary" @click="onClickBack">Back </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>
<script>
import BCardCode from "@core/components/b-card-code";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import Attachment from "../../../components/Attechment.vue";
import TaskChat from "./TaskChat.vue";
import moment from 'moment'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BFormFile,
  BAvatar,
  BTabs,
  BTab

} from "bootstrap-vue";

import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axios from '@/components/axios';

export default {
  components: {
    Attachment,
    TaskChat,
    PinchScrollZoom,
    flatPickr,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BFormFile,
    BAvatar,
    BTabs,
    BTab


  },
  data() {
    return {
      documents: {
        attachment1: '',
        attachment2: '',
        voice_note: '',
      },
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      assignto: "",
      employeeoption: [],
      worktype: "",
      tasktype: "",
      occurance: "",
      selectedDay: "",
      selectedDate: "",
      cc: [],
      task: "",
      priority: "",
      description: "",
      status: "",
      deadline: null,
      remarks: "",
      ifEdit: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      id: "",
      submitDisable: false,
      userData: {},
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      assigntotype:'',
      cpoptions:[],
      userOptions:[],
      ccOptions:[],
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      recordingTime: 0,
      recordingTimer: null,
      isPlaying: false,
      tabIndex: 0

    };
  },
  mounted() {
    this.userData=JSON.parse(localStorage.getItem('userData'))

    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    // if (role !== "admin") {
    //   userData.map((item) => {
    //     if (item.modulename == "Task") {
    //       if (this.$route.params.id) {
    //         if (item.edit !== 1) {
    //           this.$router.push("/crm/task");
    //         }
    //       } else if (item.add !== 1) {
    //         this.$router.push("/crm/task");
    //       }
    //     }
    //   });
    // }

    this.employeeoption=[]
    if(this.$store.state.app.user_data.role == 'employee'){
      this.employeeoption = this.$store.state.app.all_users.filter((item)=>{
            return item.role == 'employee'
      })
      this.cpoptions = this.$store.state.app.all_users.filter((item)=>{
            return item.assignto == this.$store.state.app.user_data.id
      })
    }
    else if(this.$store.state.app.user_data.role == 'admin'){
      this.employeeoption = this.$store.state.app.all_users.filter((item)=>{
          return item.role == 'employee'
      })
      this.cpoptions = this.$store.state.app.all_users.filter((item)=>{
          return item.role == 'channelpartner'

      })
    }
    else{
      this.getUsers();
    }

    this.ifEdit = !!this.$route.params.id;
    if (this.ifEdit) {
      this.id = this.$route.params.id;
      // Check if chat tab is requested via query parameter
      if (this.$route.query.tab === 'chat') {
        this.tabIndex = 1; // Switch to chat tab (index 1)
      }
      // Load CC users first, then get edit data
      this.getAllUsersForCC().then(() => {
        this.getEditValue();
      });
    } else {
      this.getAllUsersForCC();
    }


  },
  watch: {
    '$route.query.tab'(newTab) {
      if (newTab === 'chat' && this.ifEdit) {
        this.tabIndex = 1;
      }
    },
  },
  methods: {
    handleTaskTypeChange() {
      if (this.tasktype !== 'Repeat') {
        this.occurance = "";
        this.selectedDay = "";
        this.selectedDate = "";
      }
    },
    handleOccuranceChange() {
      if (this.occurance !== 'Weekly') {
        this.selectedDay = "";
      }
      if (this.occurance !== 'Monthly') {
        this.selectedDate = "";
      }
    },
    async handleEmployeeOption(){
      this.userOptions =[]
      if(this.assigntotype == 'Employee'){
        this.userOptions = [...this.employeeoption]
      }
      else if(this.assigntotype == 'Channelpartner'){
        this.userOptions = [...this.cpoptions]
      }
    },
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== "") {
        let test = image.includes(this.imagePath)
          ? image
          : this.imagePath + image;
        return test;
      }
      return image;
    },
    async handleChangeFile(e, type, name) {
      this.submitDisable = true;
      const formData = new FormData();
      formData.append("image", e);
      formData.append("type", type);

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: formData,
        url: `${this.baseApi}/attachment`,
      };

      await axios(requestOptions)
        .then((response) => {
          this.documents[name] =  process.env.VUE_APP_IMAGE_PATH + response.data.attachment;
        })
        .catch((error) => console.log(error, "error"))
        .finally(()=>{
          this.submitDisable = false;

        })
    },
    async getEditValue() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/gettaskById/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          // if (json.data.length) {
          // }
          this.getEditItems(json.data.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    getEditItems(item) {
      item.map((item) => {
        this.id = item.id || this.$route.params.id;
        this.assigntotype = item.assignto&&item.assignto.role == 'employee'?'Employee' :(item.assignto&&item.assignto.role == 'channlepartner'?'Channlepartner':'')
        this.assignto = item.assignto;
        this.worktype = item.worktype || item.tasktype; // fallback for backward compatibility
        this.tasktype = item.tasktype;
        this.occurance = item.occurance || "";
        this.selectedDay = item.selectedDay || "";
        this.selectedDate = item.selectedDate || "";
        // Handle CC - convert array of IDs to array of user objects
        if (item.cc) {
          if (Array.isArray(item.cc)) {
            // If it's an array, map each ID to user object
            this.cc = item.cc.map(ccItem => {
              // If it's already a user object with id property
              if (typeof ccItem === 'object' && ccItem.id) {
                return ccItem;
              } 
              // If it's a number/string ID, find the user object
              else {
                const userId = typeof ccItem === 'object' ? ccItem.id : ccItem;
                // Use == for loose comparison to handle string/number ID mismatches
                const foundUser = this.ccOptions.find(user => user.id == userId);
                return foundUser || null;
              }
            }).filter(user => user !== null && user !== undefined); // Remove any null/undefined values
          } else if (typeof item.cc === 'object' && item.cc.id) {
            // Single user object
            this.cc = [item.cc];
          } else {
            // Single ID (number or string) - find user object
            const userId = item.cc;
            // Use == for loose comparison to handle string/number ID mismatches
            const ccUser = this.ccOptions.find(user => user.id == userId);
            this.cc = ccUser ? [ccUser] : [];
          }
        } else {
          this.cc = [];
        }
        this.task = item.task;
        this.priority = item.priority;
        this.description = item.description;
        this.status = item.status;
        // Format deadline if it exists, otherwise set to null
        if (item.deadline) {
          // Check if deadline is already in DD/MM/YYYY format
          if (moment(item.deadline, 'DD/MM/YYYY', true).isValid()) {
            this.deadline = item.deadline;
          } else if (moment(item.deadline).isValid()) {
            // Format from any valid date format to DD/MM/YYYY
            this.deadline = moment(item.deadline).format('DD/MM/YYYY');
          } else {
            this.deadline = null;
          }
        } else {
          this.deadline = null;
        }
        this.remarks = item.remarks;
        this.documents.attachment1 = item.attachment1;
        this.documents.attachment2 = item.attachment2;
        this.documents.voice_note = item.voice_note;
      });
      this.handleEmployeeOption()

    },
    async getUsers() {
      let url='';
      if(this.userData.role == 'admin'){
        url=`${this.baseApi}/getUsers`
      }
      else{
        url=`${this.baseApi}/getUserByParentId/${this.userData.id}`
      }
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: url,
      };
      await axios(requestOptions)
        .then((response) => {
          this.userOptions = response.data.data;
          if(this.userData.role !== 'admin'){
            this.userOptions.map((item)=>{
                if(item.children.length >0){
                  this.handleChild(item.children)
                }
            })

            let employee = this.$store.state.app.all_users.filter( item => this.$store.state.app.user_data.assignto == item.id )
            this.userOptions=[...employee,...this.userOptions]
          }

        })
        .catch((error) => console.log(error, "error"));
    },
    handleChild(children){
      children.map((item)=>{
        this.userOptions.push(item)
        if(item.children.length>0){
          handleChild(item.children)
        }
      })

    },
    async getAllUsersForCC() {
      try {
        // Ensure userData is available
        const currentUser = this.userData || (this.$store.state.app && this.$store.state.app.user_data) || {};
        const userRole = currentUser.role || (this.$store.state.app && this.$store.state.app.user_data && this.$store.state.app.user_data.role) || '';
        const userId = currentUser.id || (this.$store.state.app && this.$store.state.app.user_data && this.$store.state.app.user_data.id) || null;
        
        if (!userId) {
          console.warn('User ID not found, cannot fetch CC users');
          this.ccOptions = [];
          return;
        }
        
        let url='';
        if(userRole == 'admin'){
          url=`${this.baseApi}/getUsers`
        }
        else{
          url=`${this.baseApi}/getUserByParentId/${userId}`
        }
        
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: url,
        };
        
        const response = await axios(requestOptions);
        
        // Handle different response structures
        let usersData = [];
        if (response && response.data) {
          if (Array.isArray(response.data.data)) {
            usersData = response.data.data;
          } else if (Array.isArray(response.data)) {
            usersData = response.data;
          }
        }
        
        console.log('CC Users API Response for role:', userRole, 'Data:', usersData);
        
        if(userRole !== 'admin'){
          // For non-admin users, use store data (similar to how Assign To field works)
          // This ensures employees and other non-admin users can see relevant users
          let storeUsers = [];
          
          if(this.$store.state.app && this.$store.state.app.all_users){
            const allUsers = this.$store.state.app.all_users;
            const currentUserData = this.$store.state.app.user_data || currentUser;
            
            if(userRole == 'employee'){
              // For employees: show other employees and their assigned channel partners
              const employees = allUsers.filter((item) => {
                return item && item.role == 'employee' && item.id != userId;
              });
              
              const channelPartners = allUsers.filter((item) => {
                return item && item.assignto == userId;
              });
              
              storeUsers = [...employees, ...channelPartners];
            } else {
              // For other non-admin roles (franchise, channelpartner, etc.)
              // Use API data if available, otherwise use store data
              if(usersData && usersData.length > 0){
                // Flatten the nested children structure recursively
                const flattenedUsers = [];
                const processUsers = (users) => {
                  if (!Array.isArray(users)) return;
                  users.forEach((item) => {
                    if (!item || !item.id) return;
                    
                    // Ensure fullname exists (required by v-select)
                    if (!item.fullname) {
                      if (item.name || item.surname) {
                        item.fullname = `${item.name || ''} ${item.surname || ''}`.trim();
                      } else if (item.username) {
                        item.fullname = item.username;
                      } else {
                        item.fullname = `User ${item.id}`;
                      }
                    }
                    
                    // Create a copy without children to avoid circular references
                    const userCopy = { ...item };
                    if (userCopy.children) {
                      delete userCopy.children;
                    }
                    
                    // Only add if not already added (check by id)
                    const exists = flattenedUsers.some(u => u.id === userCopy.id);
                    if (!exists) {
                      flattenedUsers.push(userCopy);
                    }
                    
                    // Recursively process children if they exist
                    if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                      processUsers(item.children);
                    }
                  });
                };
                
                processUsers(usersData);
                storeUsers = flattenedUsers;
              } else {
                // If API returns empty, use store data filtered by role
                storeUsers = allUsers.filter((item) => {
                  return item && item.role && ['employee', 'channelpartner', 'franchise'].includes(item.role);
                });
              }
            }
            
            // Add the user's manager/parent if available
            if(currentUserData.assignto){
              const manager = allUsers.find(item => item && item.id == currentUserData.assignto);
              if(manager){
                const managerIndex = storeUsers.findIndex(u => u.id == manager.id);
                if(managerIndex === -1){
                  storeUsers.unshift(manager);
                }
              }
            }
            
            // Add users with same parent (colleagues)
            if(currentUserData.parent){
              const colleagues = allUsers.filter(item => 
                item && item.parent == currentUserData.parent && item.id != userId
              );
              colleagues.forEach(colleague => {
                const exists = storeUsers.some(u => u.id == colleague.id);
                if(!exists){
                  storeUsers.push(colleague);
                }
              });
            }
          }
          
          // Ensure fullname exists for all users
          storeUsers = storeUsers.map(user => {
            if (!user.fullname) {
              if (user.name || user.surname) {
                user.fullname = `${user.name || ''} ${user.surname || ''}`.trim();
              } else if (user.username) {
                user.fullname = user.username;
              } else {
                user.fullname = `User ${user.id}`;
              }
            }
            return user;
          });
          
          // Remove duplicates based on id
          const uniqueUsers = [];
          const seenIds = new Set();
          storeUsers.forEach(user => {
            if (user && user.id && !seenIds.has(user.id)) {
              seenIds.add(user.id);
              uniqueUsers.push(user);
            }
          });
          this.ccOptions = uniqueUsers;
          
          console.log('CC Options after processing (non-admin):', this.ccOptions.length, 'users');
        } else {
          // If admin, use the data directly and also include all users from store
          this.ccOptions = usersData.map(user => {
            // Ensure fullname exists
            if (!user.fullname) {
              if (user.name || user.surname) {
                user.fullname = `${user.name || ''} ${user.surname || ''}`.trim();
              } else if (user.username) {
                user.fullname = user.username;
              } else {
                user.fullname = `User ${user.id}`;
              }
            }
            return user;
          });
          
          if(this.$store.state.app && this.$store.state.app.all_users){
            const storeUsers = this.$store.state.app.all_users.map(user => {
              if (!user.fullname) {
                if (user.name || user.surname) {
                  user.fullname = `${user.name || ''} ${user.surname || ''}`.trim();
                } else if (user.username) {
                  user.fullname = user.username;
                } else {
                  user.fullname = `User ${user.id}`;
                }
              }
              return user;
            });
            this.ccOptions = [...storeUsers, ...this.ccOptions];
            
            // Remove duplicates based on id
            const uniqueUsers = [];
            const seenIds = new Set();
            this.ccOptions.forEach(user => {
              if (user && user.id && !seenIds.has(user.id)) {
                seenIds.add(user.id);
                uniqueUsers.push(user);
              }
            });
            this.ccOptions = uniqueUsers;
          }
          
          console.log('CC Options after processing (admin):', this.ccOptions.length, 'users');
        }
        
        // Ensure we have at least an empty array
        if (!Array.isArray(this.ccOptions)) {
          this.ccOptions = [];
        }
        
        // Force reactivity update
        this.$forceUpdate();
        
      } catch (error) {
        console.error('Error fetching CC users:', error);
        console.error('Error details:', error.response?.data || error.message);
        this.ccOptions = [];
      }
    },
    handleChildForCC(children){
      if (!Array.isArray(children)) return;
      children.forEach((item)=>{
        if (item && item.id) {
          this.ccOptions.push(item);
          if(item.children && Array.isArray(item.children) && item.children.length > 0){
            this.handleChildForCC(item.children)
          }
        }
      })
    },
    filterUsers(options, search) {
      if (!search) {
        return options;
      }
      const searchLower = search.toLowerCase();
      return options.filter(option => {
        const fullname = (option.fullname || '').toLowerCase();
        const username = (option.username || '').toLowerCase();
        return fullname.includes(searchLower) || username.includes(searchLower);
      });
    },
    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];
        this.recordingTime = 0;
        
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };
        
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          await this.handleRecordedAudio(audioBlob);
          
          // Stop all tracks to release microphone
          stream.getTracks().forEach(track => track.stop());
        };
        
        this.mediaRecorder.start();
        this.isRecording = true;
        
        // Start timer
        this.recordingTimer = setInterval(() => {
          this.recordingTime++;
        }, 1000);
        
      } catch (error) {
        console.error('Error accessing microphone:', error);
        this.$swal({
          title: "Error",
          text: "Could not access microphone. Please check permissions.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        
        // Clear timer
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
          this.recordingTimer = null;
        }
      }
    },
    async handleRecordedAudio(audioBlob) {
      this.submitDisable = true;
      
      // Convert blob to file
      const audioFile = new File([audioBlob], `voice-note-${Date.now()}.webm`, {
        type: 'audio/webm'
      });
      
      // Upload the recorded audio
      const formData = new FormData();
      formData.append("image", audioFile);
      formData.append("type", "task");

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: formData,
        url: `${this.baseApi}/attachment`,
      };

      await axios(requestOptions)
        .then((response) => {
          this.documents.voice_note = process.env.VUE_APP_IMAGE_PATH + response.data.attachment;
          this.$swal({
            title: "Success",
            text: "Voice note recorded successfully!",
            icon: "success",
            timer: 2000,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.log(error, "error");
          this.$swal({
            title: "Error",
            text: "Failed to upload voice note. Please try again.",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .finally(() => {
          this.submitDisable = false;
        });
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    togglePlayVoiceNote() {
      if (this.$refs.audioPlayer && this.documents.voice_note) {
        if (this.isPlaying) {
          this.$refs.audioPlayer.pause();
        } else {
          this.$refs.audioPlayer.play().catch(error => {
            console.error('Error playing audio:', error);
            this.$swal({
              title: "Error",
              text: "Could not play voice note. Please check the file.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          });
        }
      }
    },
    onAudioPlay() {
      this.isPlaying = true;
    },
    onAudioPause() {
      this.isPlaying = false;
    },
    onAudioEnded() {
      this.isPlaying = false;
    },
    removeVoiceNote() {
      this.$swal({
        title: "Remove Voice Note?",
        text: "Are you sure you want to remove this voice note?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, remove it!",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.documents.voice_note = '';
          this.isPlaying = false;
          if (this.$refs.audioPlayer) {
            this.$refs.audioPlayer.pause();
            this.$refs.audioPlayer.currentTime = 0;
          }
          this.$swal({
            title: "Removed!",
            text: "Voice note has been removed.",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      });
    },
    onClickBack() {
      // Stop recording if active before leaving
      if (this.isRecording) {
        this.stopRecording();
      }
      this.$router.push("/crm/task");
    },
    submitForm(e) {
      const data = {
        assignto: this.assignto.id,
        worktype: this.worktype,
        tasktype: this.tasktype,
        occurance: this.occurance || null,
        selectedDay: this.selectedDay || null,
        selectedDate: this.selectedDate || null,
        cc: this.cc && this.cc.length > 0 ? this.cc.map(user => user.id || user) : null,
        task: this.task,
        priority: this.priority,
        description: this.description,
        status: this.status,
        deadline: moment(this.deadline,'DD/MM/YYYY').format('YYYY-MM-DD'),
        remarks: this.remarks,
        attachment1: this.documents.attachment1,
        attachment2: this.documents.attachment2,
        voice_note: this.documents.voice_note,

      };
      // var ifEdit = this.$route.params.id ? true : false;
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success == false) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the All Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        if (success) {
          this.submitDisable = true;
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/task/${this.$route.params.id}`
              : `${baseApi}/task`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((response) => {
              this.submitDisable = false;

              this.$router.push("/crm/task");
              this.$swal({
                title: "Submited",
                text: response.data.message
                  ? `${response.data.message}`
                  : response.data.success
                    ? `${response.data.success}`
                    : "Update SuccessFully",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              this.submitDisable = false;

              this.$swal({
                title: "Error!",
                text: `${error}`,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  beforeDestroy() {
    // Stop recording if active when component is destroyed
    if (this.isRecording) {
      this.stopRecording();
    }
    // Clear timer if exists
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
  },
};
</script>
<style scoped>
/* Ensure search input is visible in vue-select multiple mode */
.cc-select-with-search ::v-deep .vs__dropdown-menu {
  padding-top: 0;
}

.cc-select-with-search ::v-deep .vs__search {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  padding: 8px 12px !important;
  margin: 0 !important;
  border: none !important;
  border-bottom: 1px solid #e0e0e0 !important;
  border-radius: 0 !important;
}

.cc-select-with-search ::v-deep .vs__search:focus {
  outline: none;
  border-bottom-color: #7367f0 !important;
}

.cc-select-with-search.vs--open ::v-deep .vs__search {
  display: block !important;
  visibility: visible !important;
}

.voice-note-container {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  background-color: #f8f9fa;
}

.voice-note-container .d-flex {
  margin-bottom: 8px;
}

.voice-note-indicator {
  padding: 10px;
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
  border-radius: 4px;
}

.voice-note-indicator .d-flex {
  flex-wrap: wrap;
  gap: 8px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.pulse-animation {
  animation: pulse 1.5s ease-in-out infinite;
}
</style>
